import { Component, OnInit } from '@angular/core';
import { CampuscctvserviceService } from '../service/campuscctvservice.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-dashboard-cctv-notconnected',
  templateUrl: './dashboard-cctv-notconnected.component.html',
  styleUrls: ['./dashboard-cctv-notconnected.component.scss']
})
export class DashboardCctvNotconnectedComponent implements OnInit {
  selected_value: any;
  cctvnotconnected:any []=[];
  show: boolean = true;
  filterBy: any;
  id: any;
  searchkey: string = '';
  public searchTerm: string = '';
  hide: boolean = false;
  constructor(public campuscctvserviceservice: CampuscctvserviceService, private spinner: NgxSpinnerService) { }
  ngOnInit(): void {
    this.notconnecteddata()
  }
  notconnecteddata() {
    this.spinner.show();
    this.selected_value = "STATE"
    this.campuscctvserviceservice.getcctvnotconnect(this.selected_value).subscribe((res) => { 
    
      if (res == null) {
        this.cctvnotconnected = [];
      } else {
        this.cctvnotconnected = res;
      }
      this.spinner.hide();
      
    })
    this.searchTerm = '';
    this.campuscctvserviceservice.search.subscribe((val: any) => {
      this.searchkey = val;
    });
    this.search({ event: { target: { value: '' } } });
  }
  onOptionsSelected(e: any) {
    this.show = true
    this.spinner.show();
    this.selected_value = e.target.value
    if (this.selected_value === 'STATE' || this.selected_value === 'CITY' || this.selected_value === 'CAMPUS') {
      this.campuscctvserviceservice.getcctvnotconnect(this.selected_value).subscribe((res) => {
        if (res == null) {
          this.cctvnotconnected = [];
        } else {
          this.cctvnotconnected = res;
          console.log('details',this.cctvnotconnected);
          
        }
        this.hide = false;
        this.spinner.hide();
      });
      this.searchTerm = '';
      this.campuscctvserviceservice.search.subscribe((val: any) => {
        this.searchkey = val;
      });
      this.search({ event: { target: { value: '' } } });
    }
  }
  navigatertochange(data: any) {
    console.log(data);
    this.filterBy = data.filterBy
    this.id = data.id;
    this.spinner.show();
    this.hide = true;
    if (this.filterBy == "STATE") {
      localStorage.setItem('stateId', data.id);
      this.campuscctvserviceservice.getnotconnectedright(this.filterBy, this.id).subscribe((res) => {
        console.log(res);
        this.cctvnotconnected = res;
        this.spinner.hide();
      });
      this.searchTerm = '';
      this.campuscctvserviceservice.search.subscribe((val: any) => {
        this.searchkey = val;
      })
      this.search({ event: { target: { value: '' } } });
    }
    else if (this.filterBy == "CITY") {
      localStorage.setItem('cityId', data.id);
      this.campuscctvserviceservice.getnotconnectedright(this.filterBy, this.id).subscribe((res) => {
        console.log(res);
        this.cctvnotconnected = res;
        this.spinner.hide();
      });
      this.searchTerm = '';
      this.campuscctvserviceservice.search.subscribe((val: any) => {
        this.searchkey = val;
      })
      this.search({ event: { target: { value: '' } } });
    }
    else if (this.filterBy == "CAMPUS") {
      localStorage.setItem('campusId', data.id);
      this.show = false;
      this.searchTerm = '';
      this.campuscctvserviceservice.search.subscribe((val: any) => {
        this.searchkey = val;
      })
      this.search({ event: { target: { value: '' } } });
    }
  }


  navigateBackward(data: any) {
    const filterBy = data.filterBy
    const id = data.id;
    if (filterBy == 'CAMPUS' && this.show == false) {
      this.campuscctvserviceservice.getnotconnectedright("CITY", localStorage.getItem('cityId')).subscribe((res) => {
        this.cctvnotconnected = res;
        this.show = true;
        console.log(res);
      });
      this.searchTerm = '';
      this.campuscctvserviceservice.search.subscribe((val: any) => {
        this.searchkey = val;
      })
      this.search({ event: { target: { value: '' } } });
      if (this.selected_value === "CAMPUS") {
        this.hide = false;
        this.spinner.show();
        this.campuscctvserviceservice.getcctvnotconnect(this.selected_value).subscribe((res) => {
          this.cctvnotconnected = res;
          this.spinner.hide();
        });
      }
    } else if (filterBy == 'CAMPUS' && this.show == true) {
      if (localStorage.getItem('stateId')) {
        this.spinner.show();
        this.campuscctvserviceservice.getnotconnectedright("STATE", localStorage.getItem('stateId')).subscribe((res) => {
          this.cctvnotconnected = res;
          this.spinner.hide();
          console.log(res);
        });
        this.searchTerm = '';
        this.campuscctvserviceservice.search.subscribe((val: any) => {
          this.searchkey = val;
        })
        this.search({ event: { target: { value: '' } } });
      }
      else {
        this.spinner.show();
        this.campuscctvserviceservice.getcctvnotconnect(this.selected_value).subscribe((res) => {
          // localStorage.setItem('stateId', res.id);
          this.cctvnotconnected = res;
          console.log(this.cctvnotconnected);
          this.spinner.hide();
        });
        this.searchTerm = '';
        this.campuscctvserviceservice.search.subscribe((val: any) => {
          this.searchkey = val;
        })
        this.search({ event: { target: { value: '' } } });
      }
      if (this.selected_value === "CITY") {
        this.hide = false;
        this.spinner.show();
        this.campuscctvserviceservice.getcctvnotconnect(this.selected_value).subscribe((res) => {
          this.cctvnotconnected = res;
          this.spinner.hide();
        });
      }
    }
    else if (filterBy == "CITY") {
      this.hide = false;
      this.notconnecteddata();
    }

  }

  search(event: any) {
    console.log(this.searchTerm);
    this.campuscctvserviceservice.search.next(this.searchTerm);
  }

}
